import styles from "./InlineOops.module.css";

export default function InlineOops() {
  return (
    <div className={styles.inlineOops}>
      This information could not be displayed.
    </div>
  );
}
